import { render } from "./icon-reviewed-counter-4+.svg?vue&type=template&id=16841241&scoped=true&component"
const script = {  }

import "./icon-reviewed-counter-4+.svg?vue&type=style&index=0&id=16841241&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16841241"]])

export default __exports__